import { getThemeAsset } from "@utils/theme";

interface SkinnerBoxContentProps {
  zIndex: number;
}

const SkinnerBoxContent = ({ zIndex }: SkinnerBoxContentProps) => {
  const imgSkinnerBox = getThemeAsset("/skinner-box/skinner-box.png");

  return (
    <div
      className="absolute bottom-[24px] right-[1px] flex h-[58px] w-[122px] shrink-0 items-center justify-center"
      style={{ zIndex }}
    >
      <img
        src={imgSkinnerBox}
        alt="Skinner Box"
        className="h-full w-full select-none object-contain"
      />
    </div>
  );
};

export default SkinnerBoxContent;
